import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

const _PRE_FILL_INTENSITY_CODES: Record<string, string> = {
  bootcamp: "b",
  continuous: "c",
  apprenticeship: "alt_",
};

export const generateProjectName = (cohortData: any, subject: any, language: string): string => {
  const date = new Date(cohortData.dt_created);
  const cohortDateCode = `${date
    .toLocaleString(language, {
      month: "short",
    })
    .replace(/\./g, "")}${String(date.getFullYear()).slice(-2).toLowerCase()}`;

  const languageCode = cohortData.language.startsWith("fr") ? "fr" : "int";
  const nameParts = (cohortData.name || "").split("|").map((part: string) => part.trim());
  const cohortSegmentCore = (nameParts[1] || "").toLowerCase().replace(/\s+/g, "_");
  const intensityCode = _PRE_FILL_INTENSITY_CODES[cohortData?.intensity] ?? "";
  const segment = intensityCode ? `${intensityCode}${cohortSegmentCore}` : cohortSegmentCore;
  const subjectShortName = subject.short_name.toLowerCase().replace(/\s+/g, "_");

  return segment
    ? `${cohortDateCode}_${segment}_${languageCode}_${subjectShortName}`
    : `${cohortDateCode}_${languageCode}_${subjectShortName}`;
};

export const getSubjects = (setSubjects: Function, language: string) => {
  ApiService.get("projects/subjects?status=ready")
    .then((response) => setSubjects(response.data.project_subjects))
    .catch((err) => {
      console.error("Error fetching subjects:", err);
      alert(translate(language, "PAGES.PROJECTS.MODAL.ERRORS.FETCH_SUBJECTS"));
    });
};

export const getCohort = (cohortId: number, setCohort: Function, language: string) => {
  ApiService.get(`cohorts/${cohortId}`)
    .then((response) => setCohort(response.data.cohort))
    .catch((error) => {
      console.error("Error fetching cohort:", error);
      alert(translate(language, "PAGES.PROJECTS.MODAL.ERRORS.FETCH_COHORT"));
    });
};

export const createProject = (
  payload: any,
  language: string,
  setLoading: Function,
  displayAlert: Function,
  setShowCreationModal: Function,
  resetSelectionMultipleCreation: Function,
  hideAlert: Function,
  resetSelection: Function
) => {
  setLoading(true);
  ApiService.post("projects", payload)
    .then((response) => {
      setShowCreationModal(false);
      displayAlert({
        type: "success",
        title: translate(language, "PAGES.PROJECTS.MODAL.DST_ALERT.SUCCESS.TITLE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.PROJECTS.MODAL.DST_ALERT.SUCCESS.OPEN_PROJECT"),
            variant: "secondary",
            onClick: () => {
              hideAlert();
              resetSelection();
              window.open(`/project/${response.data.project_id}`, "_blank");
            },
          },
          {
            label: translate(language, "PAGES.PROJECTS.MODAL.DST_ALERT.SUCCESS.CREATE_PROJECT"),
            variant: "primary",
            onClick: () => {
              hideAlert();
              setShowCreationModal(true);
            },
          },
        ],
      });
      resetSelectionMultipleCreation();
    })
    .catch((error) => {
      console.error("Error creating project:", error);
      setShowCreationModal(false);
      displayAlert({
        type: "danger",
        title: translate(language, "PAGES.PROJECTS.MODAL.DST_ALERT.ERROR.TITLE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.PROJECTS.MODAL.DST_ALERT.ERROR.TRY_AGAIN"),
            variant: "primary",
            onClick: () => {
              hideAlert();
              setShowCreationModal(true);
            },
          },
        ],
      });
    })
    .finally(() => setLoading(false));
};
